






















import { Component, Vue } from "vue-property-decorator";
import CommonTabs from "@/employer/components/shared/CommonTabs.vue";
import { useUserStore } from "@/shared/store/user";
import PlanTab from "@/employer/components/myprogram/PlanTab.vue";
import MyProgramNavigation from "@/employer/components/myprogram/MyProgramNavigation.vue";
import * as routes from "@/employer/route-names";
import { usePartnerSettingStore } from "@/shared/store/partnerSetting";

@Component({
  components: {
    MyProgramNavigation,
    CommonTabs,
    PlanTab,
  }
})
export default class MyPlans extends Vue {
  userStore = useUserStore();
  partnerSettingStore = usePartnerSettingStore();
  currentPlans = [];
  previousPlans = [];
  currentDate = new Date();

  async mounted () {
    const wexEmployerCode = this.userStore.currentEmployer.wexEmployerCode;
    const plans = await this.userStore.getPlanSettings(wexEmployerCode);

    plans.forEach(plan => {
      const isHSA = plan.planName.toLowerCase().indexOf("hsa") > -1 || plan.planName.toLowerCase().indexOf("health savings account") > -1;

      const isInPlanYear = this.currentDate < new Date(plan.planYearEndDate) && this.currentDate >= new Date(plan.planYearStartDate);

      if (isHSA || isInPlanYear) {
        this.currentPlans.push(plan);
      }
      else {
        this.previousPlans.push(plan);
      }
    });

    if (!this.partnerSettingStore.isLoaded) {
      this.partnerSettingStore.loadEmployerPartnerSettings({
        partnerId: this.userStore.currentEmployer.partnerId,
        employerId: this.userStore.currentEmployer.employerId
      });
    }
  }
  openLink () {
    this.$router.push({ name: routes.ProgramProducts });
  }
}
